import { Space, Tag, Typography } from 'antd';

import { ListProductLibraryModel } from '../../../../../models/product-library';

import './HeaderSectionLeft.less';

interface HeaderSectionLeftProps {
  productItem: ListProductLibraryModel | null;
  hasClientRole: boolean;
}

const { Title } = Typography;

const HeaderSectionLeft = ({
  productItem,
  hasClientRole,
}: HeaderSectionLeftProps) => {
  const renderTag = (status?: string) => {
    switch (status) {
      case 'approved':
        return (
          <Tag
            color="green"
            className="product-tag"
            style={{ color: '#003D4C', borderColor: '#003D4C' }}
          >
            Approved
          </Tag>
        );
      case 'rejected':
        return (
          <Tag
            color="red"
            className="product-tag"
            style={{ color: '#003D4C', borderColor: '#003D4C' }}
          >
            Rejected
          </Tag>
        );
      case 'needs_approval':
        return (
          <Tag
            color="orange"
            className="product-tag"
            style={{ color: '#003D4C', borderColor: '#003D4C' }}
          >
            Needs Approval
          </Tag>
        );
      case 'unknown':
        return (
          <Tag
            color="#EBF9FC"
            className="product-tag"
            style={{ color: '#003D4C', borderColor: '#003D4C' }}
          >
            Unknown
          </Tag>
        );
    }
  };

  return (
    <Space align="center">
      <Title level={4}>
        {productItem?.upc ? productItem?.upc + ' UPC' : 'No UPC'}
      </Title>
      {!hasClientRole && renderTag(productItem?.status)}
    </Space>
  );
};

export default HeaderSectionLeft;
